function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.996,5.011c1.697,0.353,8.422,4.206,9.6,5.499c0.54,1.641,0.539,9.335,0,10.979c-1.17,1.291-7.9,5.148-9.599,5.5 c-1.698-0.35-8.425-4.206-9.597-5.499c-0.535-1.648-0.535-9.334,0-10.98C7.569,9.217,14.297,5.361,15.996,5.011 M15.998,3 C14.225,3,5.535,7.983,4.658,9.503C3.78,11.024,3.781,20.984,4.659,22.499C5.54,24.018,14.229,29,15.998,29 c1.764,0,10.453-4.981,11.337-6.499c0.887-1.522,0.887-11.487,0-13.003V9.496C26.444,7.979,17.756,3,15.998,3L15.998,3z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 2,
  x: 13,
  y: 15
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 9,
  x: 18,
  y: 12
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 12,
  y: 11
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "13,9 11,11 15,11"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "19,23 21,21 17,21"
});

function SvgHackerRank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackerRank);
export default __webpack_public_path__ + "static/media/HackerRank.012b9b43.svg";
export { ForwardRef as ReactComponent };